import { render, staticRenderFns } from "./shelf-cycle.vue?vue&type=template&id=4a5fae96&scoped=true&"
import script from "./shelf-cycle.vue?vue&type=script&lang=js&"
export * from "./shelf-cycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5fae96",
  null
  
)

export default component.exports